import { render, staticRenderFns } from "./softInformation.vue?vue&type=template&id=5de7c1b5&scoped=true"
import script from "./softInformation.vue?vue&type=script&lang=js"
export * from "./softInformation.vue?vue&type=script&lang=js"
import style0 from "./softInformation.vue?vue&type=style&index=0&id=5de7c1b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de7c1b5",
  null
  
)

export default component.exports